import React, { useContext } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import AuthContext from '../../AuthContext';

const Layout = () => {
  const location = useLocation();
  const { sidebarCollapsed, mode } = useContext(AuthContext); // 👈 mode from context

  const isLoginPage = location.pathname === '/login';

  const drawerWidth = 260;
  const collapsedWidth = 70;
  const sidebarWidth = sidebarCollapsed ? `${collapsedWidth}px` : `${drawerWidth}px`;

  // Determine background based on mode
  const mainBg = mode === 'light' ? '#ffffff' : '#1e1e1e'; // or use any light/dark colors you like

  if (isLoginPage) {
    return (
      <div style={{ minHeight: '100vh', backgroundColor: mainBg }}>
        <Outlet />
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', height: '100vh', backgroundColor: mainBg }}>
      <div style={{ width: sidebarWidth, flexShrink: 0, borderRight: `1px solid ${mode === 'light' ? '#e5e7eb' : '#444'}` }}>
        <Sidebar />
      </div>

      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
        <Header />
        <main style={{ flex: 1, overflowY: 'auto', padding: '1vw', backgroundColor: mainBg }}>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
